import { combineReducers, Reducer } from '@reduxjs/toolkit';

import { Action as RootAction } from '@occc-app/rootRedux/action';

import { default as types, State } from './types';

import { reducer as segmentMemberships } from '../components/SegmentMembershipAssignment/redux';

const initialState: State['segment'] = {
  __typename: 'Segment',
  uuid: '',
  description: '',
  id: '',
  shortCode: '',
  name: '',
  membershipCount: 0,
};

const segment: Reducer<State['segment']> = function (
  state: State['segment'] = initialState,
  action: RootAction,
) {
  switch (action.type) {
    case types.REQUEST_SEGMENT_OK:
      return {
        ...state,
        ...action.segment,
      };
  }
  return state;
};

export default combineReducers<State>({
  segment,
  segmentMemberships: segmentMemberships as any,
});
